module.exports = __webpack_public_path__ + "static/img/1-1.a5d89bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/5/eng/1-1.png
// module id = y90S
// module chunks = 0